export class BaseStoreModel {
    constructor(isLoading = false) {
        this.isLoading = isLoading;
    }
}